import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { GaIconComponent, GaTooltipModule } from '@vsn-ux/ngx-gaia';

import { NavbarBrandOptionComponent } from './navbar-brand-option/navbar-brand-option.component';
import { NavbarBrandComponent } from './navbar-brand/navbar-brand.component';
import { NavbarMenuItemLabelDirective } from './navbar-menu-item/navbar-menu-item-label.directive';
import { NavbarMenuItemComponent } from './navbar-menu-item/navbar-menu-item.component';
import { NavbarMenuComponent } from './navbar-menu/navbar-menu.component';
import { NavbarRightMenuComponent } from './navbar-right-menu/navbar-right-menu.component';
import { NavbarSecondaryMenuMobileComponent } from './navbar-secondary-menu-mobile/navbar-secondary-menu-mobile.component';
import { NavbarSecondaryMenuComponent } from './navbar-secondary-menu/navbar-secondary-menu.component';
import { NavbarComponent } from './navbar.component';
import { NavbarConfig, VUD_NAVBAR_CONFIG } from './navbar.config';
import { NavbarService } from './navbar.service';
import {
  VudDropdownDirective,
  VudDropdownMenuDirective,
  VudDropdownToggleDirective,
} from './vud-dropdown';

@NgModule({
  imports: [
    CommonModule,
    CdkMenuModule,
    GaTooltipModule,
    GaIconComponent,
    NavbarMenuItemLabelDirective,
    VudDropdownDirective,
    VudDropdownToggleDirective,
    VudDropdownMenuDirective,
  ],
  declarations: [
    NavbarComponent,
    NavbarBrandComponent,
    NavbarBrandOptionComponent,
    NavbarMenuComponent,
    NavbarMenuItemComponent,
    NavbarRightMenuComponent,
    NavbarSecondaryMenuComponent,
    NavbarSecondaryMenuMobileComponent,
  ],
  exports: [
    NavbarComponent,
    NavbarBrandComponent,
    NavbarBrandOptionComponent,
    NavbarMenuComponent,
    NavbarMenuItemComponent,
    NavbarMenuItemLabelDirective,
    NavbarRightMenuComponent,
    NavbarSecondaryMenuComponent,
    NavbarSecondaryMenuMobileComponent,
    VudDropdownDirective,
    VudDropdownToggleDirective,
    VudDropdownMenuDirective,
  ],
  providers: [NavbarService],
})
export class NavbarModule {
  static withConfig(config: NavbarConfig): ModuleWithProviders<NavbarModule> {
    return {
      ngModule: NavbarModule,
      providers: [{ provide: VUD_NAVBAR_CONFIG, useValue: config }],
    };
  }
}
